import AppTable from 'components/basic/AppTable';
import { useItems } from 'hooks/atoms/items-hook';
import CollectionKeys from 'hooks/molecules/collection-keys';
import axiosClient from 'http/axios-client';
import React, { useCallback, useState } from 'react';
import { useQueryClient } from 'react-query';
import { Button } from '@material-ui/core';
import PromoCodesEditDialog from './PromoCodesEditDialog';

const PromoCodesTable = () => {
  const [ filterQuery, setFilterQuery ] = useState({ });

  const {
    items: promoCodes,
    itemsLoading: promoCodesLoading,
    pagination,
    refetch,
  } = useItems(CollectionKeys.PROMO_CODES, {
    filterQuery,
  });

  const [ activePromoCode, setActivePromoCode ] = useState();
  const [ promoCodePopupOpen, setPromoCodePopupOpen ] = useState(false);

  const queryClient = useQueryClient();

  const handleEditAction = useCallback((e, rowId) => {
    const foundPromoCode = promoCodes?.find((s) => { return s.id === rowId; });
    if (foundPromoCode) {
      setActivePromoCode(foundPromoCode);
      setPromoCodePopupOpen(true);
    }
  }, [ promoCodes ]);

  const handlePromoCodeEdit = useCallback((updatedPromoCode) => {
    if (activePromoCode !== undefined) {
      axiosClient.put(`${ CollectionKeys.PROMO_CODES }/${ activePromoCode.id }`, {
        ...updatedPromoCode,
      }).finally(() => {
        setActivePromoCode(undefined);
        setPromoCodePopupOpen(false);
        queryClient.invalidateQueries([ CollectionKeys.PROMO_CODES ]);
      });
    } else {
      axiosClient.post(CollectionKeys.PROMO_CODES, {
        ...updatedPromoCode,
        already_used: false,
      }).finally(() => {
        setActivePromoCode(undefined);
        setPromoCodePopupOpen(false);
        queryClient.invalidateQueries([ CollectionKeys.PROMO_CODES ]);
      });
    }
  }, [ activePromoCode ]);

  const tableColumns = [
    { id: 1, label: 'Code', field: 'code' },
    { id: 220,
      label: 'Price',
      field: 'amount' },
    { id: 234, label: 'Thematic Package', field: 'thematic_package.real_name', noSort: true },
    { id: 3,
      label: 'Date from',
      field: 'date_from',
      customRenderer({
        row,
      }) {
        return (
          <div>
            {new Date(row.date_from).toLocaleDateString('el-GR')}
          </div>
        );
      } },
    { id: 4,
      label: 'Date To',
      field: 'date_to',
      customRenderer({
        row,
      }) {
        return (
          <div>
            {new Date(row.date_to).toLocaleDateString('el-GR')}
          </div>
        );
      } },
    { id: 5,
      label: 'Email',
      field: 'customer_email' },
    { id: 6,
      label: 'Already used',
      field: 'already_used',
      customRenderer({
        row,
      }) {
        return (
          <div>
            {'' === row.customer_email || null === row.customer_email ? '' : `${ row.already_used }`}
          </div>
        );
      } },
  ];

  return (
    <>
      {
        promoCodePopupOpen && (
          <PromoCodesEditDialog
            promoCode={ activePromoCode }
            handleClose={ () => {
              setActivePromoCode(undefined);
              setPromoCodePopupOpen(false);
            } }
            handleSubmit={ handlePromoCodeEdit }
            open={ promoCodePopupOpen }
          />
        )
      }
      <AppTable
        columns={ tableColumns }
        data={ promoCodes }
        loading={ promoCodesLoading }
        paginationProps={ pagination }
        EditProp={ { handleEdit: handleEditAction } }
        refetch={ refetch }
        advancedFiltersProps={
          {
            properties: [
            ],
            initialAndFilterOptions: [],
            onQueryChange: setFilterQuery,
          }
        }
      />

      <Button
        color='secondary'
        onClick={ () => {
          setActivePromoCode(undefined);
          setPromoCodePopupOpen(true);
        } }
        style={ {
          position: 'relative',
          color: 'white',
          top: '-52px',
        } }
        variant='contained'
      >
        Add promo code
      </Button>
    </>
  );
};

export default PromoCodesTable;
